import styled from "styled-components";

const Wrapper = styled.div`
  label {
    margin-left: 1.2rem;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  height: 25px;
  width: 25px;
  border: ${(props) =>
    props.checked ? "2px solid var(--primary)" : "1px solid #cccccc"};
  border-radius: 50%;
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: var(--primary);
    display: ${(props) => (props.checked ? "block" : "none")};
  }

  input {
    visibility: hidden;
  }
`;

const RadioInput = ({
  id,
  className,
  name,
  grey,
  label,
  value,
  checked,
  required = false,
  disabled,
  onClick,
}) => {
  const radioInputSelector = `input[type="radio"][id=${id}][name=${name}]`;

  const handleClick = () => {
    document.querySelector(radioInputSelector).click();
    onClick?.()
  }

  return (
    <Wrapper className="flexRow alignCenter">
      <Box
        grey={grey}
        checked={checked}
        onClick={handleClick}
        className={className}
      >
        <input
          type="radio"
          name={name}
          id={`${id}`}
          value={value}
          required={required}
          disabled={disabled}
        />
      </Box>
      {label && (
        <label htmlFor={`${id}`} className="l3 ellipsify">
          {label}
        </label>
      )}
    </Wrapper>
  );
};

export default RadioInput;